(function () {
  function safeParseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function patchCartDrawer() {
    const CartDrawerClass = customElements.get('cart-drawer');
    if (!CartDrawerClass) return;

    CartDrawerClass.prototype.getSectionInnerHTML = function (html, selector = '.shopify-section') {
      const doc = safeParseHTML(html);
      const el = doc.querySelector(selector);
      return el ? el.innerHTML : null;
    };

    CartDrawerClass.prototype.getSectionsToRender = function () {
      return [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer',
        },
        {
          id: 'cart-icon-bubble',
          selector: '.shopify-section',
        },
      ];
    };

    CartDrawerClass.prototype.renderContents = function (parsedState) {
      const drawerInner = this.querySelector('.drawer__inner');
      if (drawerInner && drawerInner.classList.contains('is-empty')) {
        drawerInner.classList.remove('is-empty');
      }

      this.productId = parsedState.id;

      const sections = this.getSectionsToRender();

      sections.forEach((section) => {
        if (!parsedState.sections || !parsedState.sections[section.id]) return;

        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);

        if (!sectionElement) return;

        const html = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector || '.shopify-section'
        );

        if (html !== null) {
          sectionElement.innerHTML = html;
        }
      });

      setTimeout(() => {
        const overlay = this.querySelector('#CartDrawer-Overlay');
        if (overlay) {
          overlay.onclick = this.close.bind(this);
        }
        this.open();
      });
    };

    const CartDrawerItemsClass = customElements.get('cart-drawer-items');
    if (CartDrawerItemsClass) {
      CartDrawerItemsClass.prototype.getSectionsToRender = function () {
        return [
          {
            id: 'cart-drawer',
            section: 'cart-drawer',
            selector: '#CartDrawer .drawer__inner',
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
          },
        ];
      };
    }
  }

  function patchProductForm() {
    const ProductFormClass = customElements.get('product-form');
    if (!ProductFormClass) return;

    ProductFormClass.prototype.onSubmitHandler = function (evt) {
      evt.preventDefault();

      if (!this.submitButton) return;
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.error = false;

      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

      this.submitButton.setAttribute('aria-disabled', 'true');
      this.submitButton.classList.add('loading');

      const spinner = this.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id).join(',')
        );
        formData.append('sections_url', window.location.pathname);

        if (typeof this.cart.setActiveElement === 'function') {
          this.cart.setActiveElement(document.activeElement);
        }
      }

      config.body = formData;

      fetch(routes.cart_add_url, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.error = true;

            if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartError) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
            }

            this.handleErrorMessage(response.description || response.message || 'Er ging iets mis. Probeer opnieuw.');
            return;
          }

          if (!this.cart || typeof this.cart.renderContents !== 'function') {
            window.location.href = window.routes.cart_url;
            return;
          }

          if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });
          }

          const quickAddModal = this.closest('quick-add-modal');

          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((error) => {
          console.error('HORAVO CART FIX ERROR:', error);
          this.error = true;
          this.handleErrorMessage('Er ging iets mis. Probeer opnieuw.');
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');

          const spinnerEl = this.querySelector('.loading__spinner');
          if (spinnerEl) spinnerEl.classList.add('hidden');

          if (this.cart && this.cart.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }

          if (!this.error) {
            this.submitButton.removeAttribute('aria-disabled');
          }
        });
    };
  }

  function initPatch() {
    customElements.whenDefined('cart-drawer').then(() => {
      patchCartDrawer();
    });

    customElements.whenDefined('product-form').then(() => {
      patchProductForm();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPatch);
  } else {
    initPatch();
  }
})();